export const ADVOX_POPUP_PREFIX = 'advox_popup';
export const POPUP_NEWSLETTER_TYPE = 1;
export const POPUP_PROMOTION_TYPE = 0;
export const POPUP_SHOW_AFTER = 10000;
